export const T = {
  en_GB: {
    title: "You do not have access to this client",
    privateOwner: (owner: string) =>
      `This client is private. Ask the client owner, ${owner}, for access.`,
    privateNoOwner: "This client is private and has no owner. Ask an administrator for access.",
    team: (teams: string) =>
      `This client is limited to ${teams}. Ask an administrator to add you to one of them.`,
    back: "Back to Clients",
  },
  nb_NO: {
    title: "Du har ikke tilgang til denne kunden",
    privateOwner: (owner: string) =>
      `Denne kunden er privat. Be kundens eier, ${owner}, om tilgang.`,
    privateNoOwner: "Denne kunden er privat og har ingen eier. Be en administrator om tilgang.",
    team: (teams: string) =>
      `Denne kunden er begrenset til ${teams}. Be en administrator legge deg til i en av dem.`,
    back: "Tilbake til kunder",
  },
} as const;
